import { render, staticRenderFns } from "./secondClaimDialog1.vue?vue&type=template&id=fd615eb0"
import script from "./secondClaimDialog1.vue?vue&type=script&lang=js"
export * from "./secondClaimDialog1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports